import ChangePassword from "./change-password";

export default ChangePassword